module.exports = __webpack_public_path__ + "img/SH2D_300006.843dcca2.png";